export default "__VITE_ASSET__DMgF0pak__"